<template>
    <b-form-input
        type="text"
        :id="id"
        v-model="localValue"
        :size="getSize"
        v-on="$listeners"
        autocomplete="off"
        @keydown="checkPattern($event)"
        @blur="checkFormat()"
        />
</template>

<script>
export default {
    props: ['id', 'value', 'size'],
    computed: {
        //propriedade necessaria para resolver o problema de mutating prop e evitar a alteracao da prop pelo componente filho
        localValue: {
            get() {return this.value},
            set(localValue) {this.setLocalValue(localValue);}
        },
        getSize() {
            if(this.size)
                return this.size;
            return "md"
        }
    },
    methods: {
        //metodo necessario para resolver o problema de mutating prop e evitar a alteracao da prop pelo componente filho
        setLocalValue(newValue) {
            this.$emit('input', newValue);
        },
        checkPattern(event) {
            if(!this.isAllowedEvent(event.code, event)) {
                if(!this.onlyNumericAndComma(event.key))
                    event.preventDefault();
                if(this.isAnotherComma(event.key))
                    event.preventDefault();
            }
            if(this.isAnotherNegativeSymbol(event.key))
                event.preventDefault();
            if (this.value === '') this.setLocalValue(undefined);
        },
        isAllowedEvent(keyCode, event) {
            return (this.allowNegative && event.key === '-') || keyCode === 'Backspace' || keyCode === 'Delete' || keyCode === 'ArrowLeft' || keyCode === 'ArrowRight' || keyCode === 'Home' || keyCode === 'End' || keyCode === 'ShiftLeft' || keyCode === 'Tab' || keyCode === 'Enter' || (keyCode === 'KeyA' && event.ctrlKey);
        },
        onlyNumericAndComma(key) {
            return /[\d\,{1}]+/i.test(key);
        },
        isAnotherComma(key) {
            return key === "," && this.value.search(',') >= 0;
        },
        isAnotherNegativeSymbol(key) {
            return key === "-" && this.value.search('-') >= 0;
        },
        checkFormat() {
            if(this.value && !this.isIncorrectNegativeFormat()) {
                if(this.noDecimal())
                    this.setLocalValue(this.value + ',0000');
                else {
                    if(this.startWithComma())
                        this.setLocalValue('0' + this.value);
                    this.fillDecimalZeros();
                    if(this.hasMoreThanFourDecimalDigit())
                        this.setLocalValue(this.value.slice(0, -(this.getDecimal().length - 4)));
                }
            }
            else {
                this.setLocalValue(null);
            }
        },
        isIncorrectNegativeFormat() {
            return this.value.search('-') > 0 || (this.value.search('-') === 0 && this.value.length === 1);
        },
        noDecimal() {
            return this.value.search(',') < 0;
        },
        startWithComma() {
            return this.value.search(',') === 0;
        },
        getDecimal() {
            return this.value.split(',')[1];
        },
        noDecimalDigitAfterComma() {
            return this.getDecimal().length === 0;
        },
        hasJustOneDecimalDigit() {
            return this.getDecimal().length === 1;
        },
        hasMoreThanFourDecimalDigit() {
            return this.getDecimal().length > 4;
        },
        fillDecimalZeros(){
            var missingZeros = 4 - this.getDecimal().length;
            if(missingZeros > 0) this.setLocalValue(this.value + '0'.repeat(missingZeros));
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/BlumarExchangeInput.vue